export const parseTagsInput = (input: string): string[] => {
  if (!input) return [];

  // Split by spaces, commas, newlines
  const rawTokens = input
    .split(/[\s,]+/)
    .map((token) => token.trim())
    .filter(Boolean);

  const normalized: string[] = [];
  const seen = new Set<string>();

  for (const token of rawTokens) {
    // Remove leading '#' characters
    const withoutHash = token.replace(/^#+/, '');
    if (!withoutHash) {
      continue;
    }

    const lower = withoutHash.toLowerCase();
    const tag = `#${lower}`;

    if (!seen.has(tag)) {
      seen.add(tag);
      normalized.push(tag);
    }
  }

  return normalized;
};

export const normalizeTagsForTyping = (input: string): string => {
  if (!input) return "";

  return input
    .split(" ")
    .map((token) => {
      if (token === "") return token;

      const withoutHash = token.replace(/^#+/, "");
      return withoutHash ? `#${withoutHash}` : "";
    })
    .join(" ");
};

export const formatTagsForInput = (tags: string[]): string => {
  if (!Array.isArray(tags) || tags.length === 0) return '';
  // Join tags with space for input display
  return tags.join(' ');
};
